import { useController } from "react-hook-form";
import type { DistributedOmit } from "type-fest";
import type { Lens } from "@hookform/lenses";
import { Switch } from "@design-lab/shared/ui";
import type { SwitchProps } from "@design-lab/shared/ui";

export type SwitchInputProps = DistributedOmit<SwitchProps, "isSelected" | "onChange"> & {
  lens: Lens<boolean>;
  onCheckedChange?: (checked: boolean) => void;
};

export function SwitchInput(props: SwitchInputProps) {
  const { lens, onCheckedChange, ...rest } = props;
  const { field } = useController(lens.interop());

  const handleCheckedChange = (checked: boolean) => {
    field.onChange(checked);
    onCheckedChange?.(checked);
  };

  return <Switch isSelected={field.value} onChange={handleCheckedChange} {...rest} />;
}
